import { createSlice } from '@reduxjs/toolkit'

import { SLICES } from '@/reducers/utils/constants'

import { extraReducers, reducers } from './reducers'

export const initialState = {}

const onlineResourceModal = createSlice({
  extraReducers,
  initialState,
  name: SLICES.onlineResourceModal,
  reducers
})

export const { actions } = onlineResourceModal
export default onlineResourceModal
